const en={
    "button":{
        "Back":"Back",
        "Add":"Add",
        "Search":"Search",
        "Find":"Find",
        "Delete":"Delete",
        "Reset":"Reset",
        "Edit":"Edit",
        "Save":"Save",
        "Pass":"Pass",
        "Return":"Return",
        "ReturnPage":"Return",
        "Upload and Check":"Upload and Check",
        "Upload to the database":"Upload to the database",
        "Modify the information":"Modify the information",
        "Modify the password":"Modify the password",
        "Log in":"Log in",
        "Log out":"Log out",
        "Go back and Log in":"Go back and Log in",
        "Register":"Register",
        "Add the information of Country":"Add the Country",
        "Add the information of City":"Add the City",
        "Add the information of Index":"Add the Index",
        "Add the information of Data":"Add the Data",
        "Compute":"Compute",
        "NotVerify":"NotVerify",
        "AlreadyVerify":"AlreadyVerify",
        "ReturnVerify":"ReturnVerify"
    },
    "title":{
        "Login Title":"Log In Your Account",
        "Register Title":"Register Your Account",
        "Modify Title":"Modify Account Information",
        "Change Title":"Modify Password",
        "Main Title":"World Tourism Cities Report Database",
        "Compute":"Index Score Calculation",
        "Introduction":"About the World Tourism Cities Report Database System",
        "Introduction1":"The World Tourism City Report Database System is used to realize the exchange and sharing of world tourism city report data among tourism cities and professional tourism institutions",
        "Introduction2":"Promote the multi-dimensional and in-depth mining of the intrinsic value of the World Tourism Cities' report data, and promote the integration and automation of the World Tourism Cities Federation's business processes",
        "Introduction of Video Train":"Introduction of Video Train"
    },
    "tips":{
        "Login tips1":"If you are using this system for the first time, please register first",
        "Login tips2":"After successful registration, the administrator is required to grant permissions to the account",
        "Login tips3":"Log in to the system with the user name and password",
        "Compute": "Tip:",
        "Compute1": "This function is used to calculate the scores of all level index of all cities in a whole year",
        "Compute2": "Select the year to be calculated",
        "Compute3": "Then you can calculate the scores of all index in the year",
        "Modify tips1":"The old password cannot be empty",
        "Modify tips2":"The old password is incorrect",
        "Modify tips3":"The new password cannot be empty",
        "Modify tips4":"The confirmed password cannot be empty",
        "Modify tips5":"Password length is between 3 and 20 characters",
        "Modify tips6":"The new password is different from the confirmed password",
        "Modify tips7":"The new password is the same as the old one"
    },
    "Login and Register":{
        "Username":"Username",
        "Password":"Password",
        "Confirm Password":"ConfirmPassword",
        "New Password":"New Password",
        "Old Password":"Old Password",
        "Organization":"Organization",
        "City":"City",
        "Phone number":"PhoneNumber",
        "Email":"Email",

        "UsernameTip":"Username cannot be empty",
        "PasswordTip1":"Password cannot be empty",
        "PasswordTip2":"Password length is between 3 and 20 characters",
        "ConfirmPasswordTip1":"Please enter the password again",
        "ConfirmPasswordTip2":"The passwords entered twice are inconsistent!",
        "PhoneNumberTip1":"Please enter valid contact information",
        "PhoneNumberTip2":"Phone Number cannot be empty",
        "CityNameTip1":"City cannot be empty",
        "EmailTip1":"Please enter the email address",
        "EmailTip2":"Please enter the correct email address",
    },
    "Navigation":{
        "Data Search Module":"Data Search Module",
        "City Evaluation System":"City Evaluation System",
        "City Detail Data":"City Detail Data",
        "City Index Rank":"City Index Rank",

        "Data Analysis Module": "Data Analysis Module",
        "Comparative Analysis of City Data":"Comparative Analysis of City Data",
        "Trend Analysis of City Data":"Trend Analysis of City Data",

        "Account Management Module":"Account Management Module",
        "Account Permission Modification":"Account Permission Modification",

        "Data Maintenance Module": "Data Maintenance Module",
        "City Management": "City Management",
        "Index Management": "Index Management",
        "Data Management": "Data Management",
        "Index calculation": "Index calculation",

        "Data Upload Module": "Data Upload Module",
        "Batch Data Upload": "Batch Data Upload",

        "Data Audit Module":"Data Audit Module",
        "Batch Data Audit": "Batch Data Audit",

        "Video Train Module":"Video Train Module",
        "Video Train": "Video Train",

        "City Evaluation System1":"Search the evaluation system in different years",
        "City Detail Data1":"Search index values and index scores of different cities in different years",
        "City Index Rank1":"Search the ranking of all cities according to different index values",

        "Comparative Analysis of City Data1":"Search the index value comparison chart of two cities in a certain year",
        "Trend Analysis of City Data1":"Search the index development trend chart of a city",

        "City Management1": "Add country and city information; Modify city information",
        "Index Management1": "Add and modify index information",
        "Data Management1": "Add and modify data information",
        "Index calculation1": "Calculate the score of all city index",
    },
    "placeholder":{
        "Year":"Year",
        "Year1":"Year(Multiple choices)",
        "Year2":"Year*",
        "Year3":"Select the year to query*",

        "Index":"Index",
        "Index1":"Index(Multiple choices)",
        "Index2":"Index*",
        "Index3":"index value",
        "Index4":"index score",
        "Index5":"(CN)Index*",
        "Index5-e":"(EN)index*",
        "Index6":"parent-index of added index(Optional)",
        "Index6-e":"(EN)parent-index of added index(Optional)",
        "Index7":"(CN)index unit(Optional)",
        "Index7-e":"(EN)index unit(Optional)",
        "Index8":"index weight(Optional)",

        "City0":"City",
        "City":"City*",
        "City1":"City1*",
        "City2":"City2*",
        "City3":"City(Optional)",
        "City4":"City(Multiple choices)",
        "City5":"City",
        "City5CN":"(CN)City*",
        "City5EN":"(EN)City*",

        "Search":"Search by UserName",
        "Continent":"Continent",
        "Country":"Country",
        "Country1":"Country",
        "Country1CN":"(CN)Country*",
        "Country1EN":"(EN)Country*",
    },
    "label":{
        "item_name":"item.name_en",
        "oneIndex":"Level I index",
        "oneIndexValue":"Weights of Level I index(%)",
        "twoIndex":"Level II index",
        "twoIndexValue":"Weights of Level II index(%)",

        "Rank":"Rank",
        "CityName":"City",
        "CityNameCN":"City(CN)",
        "CityNameEN":"City(EN)",
        "IndexName":"Index",
        "IndexNameCN":"Index(CN)",
        "IndexNameEN":"Index(EN)",
        "Score":"Score",
        "IndexYear":"Year",
        "Value":"Value",
        "Continent":"Continent" ,
        "Continent-1":"Continent" ,
        "Country-1":"Country" ,
        "Country":"Country" ,
        "Operation":"Operations" ,
        "Unit":"Unit" ,
        "Weight":"Weight",
        "UnitCN":"Unit(CN)",
        "UnitEN":"Unit(EN)",
        "Parent":"ParentIndex" ,

        "ReturnTime":"ReturnTime",
        "ConfirmTime":"ConfirmTime",
        "UploadTime": "UploadTime",
        "UploaderUsername": "UploaderUsername",
        "ConfirmerUsername": "ConfirmerUsername",
        "Source": "Source",
        "Approved": "Approved",
        "Username": "Username",
        "Organization": "Organization",
        "City": "City",
        "PhoneNumber": "PhoneNumber",
        "Email": "Email",
        "Opening Account": "Opening Account",
        "Roles":"Roles",
        "Open":"open",
        "Close":"close",
        "empty":"No data yet"
    },
    "video": {
        "Cultural and Tourism Product Investment":"Cultural and Tourism Product Investment and Chinese Tourist Consumption Trends——Wang Xiaoyu",
        "Sustainable Travel and Tourism":"Sustainable Travel and Tourism: Best Practices in Destinations——Chen Yining",
        "Innovative Technology":"Innovative Technology Promotes the Recovery of Urban Tourism in China——Zhang Huiying",
        "Market Logic and Evolution of Sports Tourism":"Market Logic and Evolution of Sports Tourism in China——Jiang Yiyi",
        "Introduction of Cultural and Tourism Product Investment":"The course analyzes cultural and tourism product investment and Chinese tourist consumption demand from four aspects: the current status of resources and markets in the \"Belt and Road\" initiative, the trend of changes in China's cultural and tourism consumption demand, investment and trends in the \"Belt and Road\" cultural and tourism industry, and risk control in \"Belt and Road\" investment. It suggests that leisure and vacation consumption in China has increased significantly, with a greater emphasis on quality and experience. Currently, investment in the \"Belt and Road\" cultural and tourism industry is transforming from heavy asset investment in hotels and travel to light asset investment in online, entertainment, and commercial fields.",
        "Introduction of Sustainable Travel and Tourism":"The course elaborates on the sustainable development of tourist destinations from four aspects: the necessity of sustainable tourism development, the gap between tourists' words and actions, product solutions for sustainable tourism development, and best practices. Tourism is an important means to achieve the United Nations' Sustainable Development Goals, and many tourists are aware of this. However, for various reasons, they may choose less sustainable methods during the actual process of traveling. Therefore, to create a sustainable tourist destination, it is necessary to subsidize the industry, reduce carbon dioxide emissions, and achieve sustainable goals by providing sustainable tourism products and changing tourists' mindsets.",
        "Introduction of Innovative Technology":"The course is mainly divided into two parts: an overview of the Chinese tourism market and innovative cases in Chinese tourism. The course points out that the Chinese tourism market has recovered rapidly after the pandemic, with an increased preference among tourists for culture and history. Various sectors such as live streaming, online travel agencies (OTAs), hotels, and airlines have all made adjustments to cater to the surging demand for travel and the new preferences of tourists. The Forbidden City and the 798 Art Zone, as two important cultural venues in Beijing, have integrated technology with tourism to provide visitors with a brand new travel experience.",
        "Introduction of Market Logic and Evolution of Sports Tourism":"The course is presented from four perspectives: policy support, market trends, industrial development, and changes in business models. China's national policies strongly support the development of sports and promote the integration of sports with tourism across industries. The market shows three major characteristics of sports tourism enthusiasts: choosing travel destinations based on sports activities, a younger demographic of the clientele, and a diversification and personalization of sports tourism experiences. On this basis, the sports tourism industry has expanded, forming a tourism industry chain centered around events, and further promoting the development of related industries. The entire sports tourism industry is moving towards a direction of quality, boutique, and diversity."
    }
}
export default en